import styled from 'styled-components'
import CreationToolFontSize from '../../../../types/font-size'
import SelectListComponent from '../../../select-list'
import { SourceEditorCaptionStyle } from '../../types'

const SelectList = styled(SelectListComponent)`
    width: 100%;
`

type Props = {
    captionStyle: SourceEditorCaptionStyle
    setCaptionStyle: (style: SourceEditorCaptionStyle) => void
}

const CreationSourceEditorCaptionSizeDropwdown = ({ captionStyle, setCaptionStyle }: Props) => {
    const { fontSize: currentFontSize } = captionStyle
    const allSizes = CreationToolFontSize.all()

    const onChange = (fontSize: CreationToolFontSize) => {
        setCaptionStyle({
            ...captionStyle,
            fontSize,
        })
    }

    return (
        <SelectList
            {...{
                onChange,
                value: currentFontSize,
                options: allSizes.map((fontSize) => ({
                    value: fontSize,
                    label: CreationToolFontSize.title(fontSize),
                })),
            }}
        />
    )
}

export default CreationSourceEditorCaptionSizeDropwdown
